<template>
  <div class="wrap">
    <v-main :class="colorMode" :style="{ background: '#242739' }">
      <Title />
      <v-row justify="center">
        <v-col lg="4" md="6" sm="8" cols="12" class="pt-0 pb-0">
          <v-row justify="center">
            <v-col cols="12">
              <v-card class="mx-auto mb-6 pt-2" :color="backgroundColor" dark>
                <Dashboard
                  :infection1day="patient1DayLatest"
                  :infection7days="patient7DaysLatest"
                  :infectionTotal="patientTotalLatest"
                  :hospitalize="summaryOKA.hospitalize"
                  :moderate="summaryOKA.moderate"
                  :severe="summaryOKA.severe"
                  :dead="summaryOKA.dead"
                  :alertLevel="summaryAll.summary_All.alertLevel"
                  v-bind:recuperation="summaryOKA.hotel + summaryOKA.home"
                  :waiting="summaryOKA.wait"
                  v-bind:lastUpdate="summryUpdatedate"
                  v-bind:patient7dayslastUpdate="patientList7DaysUpdatedate"
                  :patient7daysList="patientList7DaysLatest"
                />
              </v-card>
            </v-col>

            <v-col cols="12" class="hidden-sm-and-down">
              <v-card class="mx-auto mb-6 pt-2" :color="backgroundColor" dark>
                <div class="text-h5 text-center font-weight-bold pt-6">
                  <p>県警戒レベル判断指標</p>
                </div>
                <AlertIndicatorsV2
                  :dateRange="alertDateRange"
                  :patients="alertPatients"
                  :bed_rate="alertBedRate"
                  :severe_bed_rate="alertSevereBedRate"
                  :lastupdate="alertLastUpdateTime"
                  :alertInfo="alertInfo.alert_OKINAWA"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6" :color="backgroundColor" dark>
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>沖縄本島</p>
            </div>
            <v-row justify="center">
              <v-radio-group v-model="radio_oka" row>
                <v-radio label="1日間" value="1"></v-radio>
                <v-radio label="7日間" value="2"></v-radio>
                <v-radio label="累計" value="3"></v-radio>
              </v-radio-group>
            </v-row>
            <Map
              v-if="radio_oka == 1"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_OKA"
              :patients="group1DayOKA"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_oka == 2"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_OKA"
              :patients="group7DaysOKA"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_oka == 3"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_OKA"
              :patients="groupTotalOKA"
              :maxWidth="440"
            >
            </Map>

            <v-row justify="center">
              <div class="charts-slider">
                <v-slider
                  class="pb-0 pt-10 pl-6 pr-6"
                  v-model="oka_slider"
                  min="0"
                  :max="dateCountOfData"
                  :thumb-size="36"
                  thumb-label="always"
                  color="#FF5656"
                >
                  <template v-slot:prepend>
                    <v-icon @click="decrement_oka">
                      {{iconMinus}}
                    </v-icon>
                  </template>
                  <template v-slot:thumb-label="{ value }">
                    {{ baseDateSlider(value) }}
                  </template>
                  <template v-slot:append>
                    <v-icon @click="increment_oka">
                      {{iconPlus}}
                    </v-icon>
                  </template>
                </v-slider>
              </div>
            </v-row>

            <!--<InfectionProgressBar 
             :dateRange=alertDateRange
             :patients=alertPatients
             >
            </InfectionProgressBar>
            -->

            <v-card-text>
              <InfectionGraphic
                :infection7days="sum7daysOKA"
                :infection1day="sum1dayOKA"
                :infectionTotal="sumTotalOKA"
                :date="baseDateOfOKA"
                v-bind:hospitalize="hospitalizeOKA"
                :days="radio_oka == 1?1:radio_oka==2?7:-1"
              >
              </InfectionGraphic>
            </v-card-text>

            <v-col cols="12" class="pl-5 pr-5">
              <AgePatientsChart
                v-if="radio_oka == 1"
                :patients="groupAges1DayOKA"
                title="1 日の年齢別感染者数※"
                :subtitle="groupAges1DayOKASubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_oka == 2"
                :patients="groupAges7DaysOKA"
                title="7 日間の年齢別感染者数※"
                :subtitle="groupAges7DaysOKASubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_oka == 3"
                :patients="groupAgesTotalOKA"
                title="年齢別感染者数の累計※"
                :subtitle="groupAgesTotalOKASubTitle"
              >
              </AgePatientsChart>
            </v-col>

            <alertList
              :backgroundColor="backgroundColor"
              :alertInfo="alertInfo.alert_OKA"
            ></alertList>
          </v-card>
        </v-col>
        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6" :color="backgroundColor" dark>
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>宮古島</p>
            </div>

            <v-row justify="center">
              <v-radio-group v-model="radio_mmy" row>
                <v-radio label="1日間" value="1"></v-radio>
                <v-radio label="7日間" value="2"></v-radio>
                <v-radio label="累計" value="3"></v-radio>
              </v-radio-group>
            </v-row>
            <Map
              v-if="radio_mmy == 1"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_MMY"
              :patients="group1DayMMY"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_mmy == 2"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_MMY"
              :patients="group7DaysMMY"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_mmy == 3"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_MMY"
              :patients="groupTotalMMY"
              :maxWidth="440"
            >
            </Map>

            <v-row justify="center">
              <div class="charts-slider">
                <v-slider
                  class="pb-0 pt-10 pl-6 pr-6"
                  v-model="mmy_slider"
                  min="0"
                  :max="dateCountOfData"
                  :thumb-size="36"
                  thumb-label="always"
                  color="#FF5656"
                >
                  <template v-slot:prepend>
                    <v-icon @click="decrement_mmy">
                      {{iconMinus}}
                    </v-icon>
                  </template>
                  <template v-slot:thumb-label="{ value }">
                    {{ baseDateSlider(value) }}
                  </template>
                  <template v-slot:append>
                    <v-icon @click="increment_mmy">
                      {{iconPlus}}
                    </v-icon>
                  </template>
                </v-slider>
              </div>
            </v-row>

            <v-card-text>
              <InfectionGraphicBed
                :infection7days="sum7daysMMY"
                :infection1day="sum1dayMMY"
                :infectionTotal="sumTotalMMY"
                :date="baseDateOfMMY"
                :hospitalize="summaryMMY.patient"
                :bed="summaryAll.summary_MMY.bed"
                :days="radio_mmy == 1?1:radio_mmy==2?7:-1"
              >
              </InfectionGraphicBed>
            </v-card-text>

            <v-col cols="12" class="pl-5 pr-5">
              <AgePatientsChart
                v-if="radio_mmy == 1"
                :patients="groupAges1DayMMY"
                title="1 日の年齢別感染者数※"
                :subtitle="groupAges1DayMMYSubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_mmy == 2"
                :patients="groupAges7DaysMMY"
                title="7 日間の年齢別感染者数※"
                :subtitle="groupAges7DaysMMYSubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_mmy == 3"
                :patients="groupAgesTotalMMY"
                title="年齢別感染者数の累計※"
                :subtitle="groupAgesTotalMMYSubTitle"
              >
              </AgePatientsChart>
            </v-col>

            <alertList
              :backgroundColor="backgroundColor"
              :alertInfo="alertInfo.alert_MMY"
            ></alertList>
          </v-card>
        </v-col>
        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6" :color="backgroundColor" dark>
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>石垣・八重山</p>
            </div>

            <v-row justify="center">
              <v-radio-group v-model="radio_isg" row>
                <v-radio label="1日間" value="1"></v-radio>
                <v-radio label="7日間" value="2"></v-radio>
                <v-radio label="累計" value="3"></v-radio>
              </v-radio-group>
            </v-row>
            <Map
              v-if="radio_isg == 1"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_ISG"
              :patients="group1DayISG"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_isg == 2"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_ISG"
              :patients="group7DaysISG"
              :maxWidth="440"
            >
            </Map>
            <Map
              v-else-if="radio_isg == 3"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_ISG"
              :patients="groupTotalISG"
              :maxWidth="440"
            >
            </Map>

            <v-row justify="center">
              <div class="charts-slider">
                <v-slider
                  class="pb-0 pt-10 pl-6 pr-6"
                  v-model="isg_slider"
                  min="0"
                  :max="dateCountOfData"
                  :thumb-size="36"
                  thumb-label="always"
                  color="#FF5656"
                >
                  <template v-slot:prepend>
                    <v-icon @click="decrement_isg">
                      {{iconMinus}}
                    </v-icon>
                  </template>
                  <template v-slot:thumb-label="{ value }">
                    {{ baseDateSlider(value) }}
                  </template>
                  <template v-slot:append>
                    <v-icon @click="increment_isg">
                      {{iconPlus}}
                    </v-icon>
                  </template>
                </v-slider>
              </div>
            </v-row>

            <v-card-text>
              <InfectionGraphicBed
                :infection7days="sum7daysISG"
                :infection1day="sum1dayISG"
                :infectionTotal="sumTotalISG"
                :date="baseDateOfISG"
                :hospitalize="summaryISG.patient"
                :bed="summaryAll.summary_ISG.bed"
                :days="radio_isg == 1?1:radio_isg==2?7:-1"
              >
              </InfectionGraphicBed>
            </v-card-text>

            <v-col cols="12" class="pl-5 pr-5">
              <AgePatientsChart
                v-if="radio_isg == 1"
                :patients="groupAges1DayISG"
                title="1 日の年齢別感染者数※"
                :subtitle="groupAges1DayISGSubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_isg == 2"
                :patients="groupAges7DaysISG"
                title="7 日間の年齢別感染者数※"
                :subtitle="groupAges7DaysISGSubTitle"
              >
              </AgePatientsChart>
              <AgePatientsChart
                v-else-if="radio_isg == 3"
                :patients="groupAgesTotalISG"
                title="年齢別感染者数の累計※"
                :subtitle="groupAgesTotalISGSubTitle"
              >
              </AgePatientsChart>
            </v-col>

            <alertList
              :backgroundColor="backgroundColor"
              :alertInfo="alertInfo.alert_ISG"
            ></alertList>
          </v-card>
        </v-col>
        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6" :color="backgroundColor" dark>
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>米軍基地</p>
            </div>

            <v-row justify="center">
              <v-radio-group v-model="radio_us" row>
                <v-radio :label="getUsDataDate" value="1"></v-radio>
                <v-radio label="累計" value="2"></v-radio>
              </v-radio-group>
            </v-row>
            <MapLegacy
              v-if="radio_us == 1"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_USMilitaryBase"
              :patients="patientUSGroup[0].item"
              :maxWidth="400"
            >
            </MapLegacy>
            <MapLegacy
              v-else-if="radio_us == 2"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_USMilitaryBase"
              :patients="patientUSGroup[1].item"
              :maxWidth="400"
            >
            </MapLegacy>
            <v-card-text>
              <InfectionGraphicSimple
                :infectionTotal="summaryUs.summary.infectionTotal"
                v-bind:hospitalize="
                  summaryUs.summary.infectionTotal - summaryUs.summary.release
                "
              >
              </InfectionGraphicSimple>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="hidden-md-and-up" lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6 pt-2" :color="backgroundColor" dark>
            <div class="text-h5 text-center font-weight-bold pt-6">
              <p>県警戒レベル判断指標</p>
            </div>
            <AlertIndicatorsV2
              :dateRange="alertDateRange"
              :patients="alertPatients"
              :bed_rate="alertBedRate"
              :severe_bed_rate="alertSevereBedRate"
              v-bind:lastupdate="alertLastUpdateTime"
            />
          </v-card>
        </v-col>

        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card
            class="mx-auto mb-6 pb-6 pl-5 pr-5"
            :color="backgroundColor"
            dark
          >
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>ワクチン接種率</p>
            </div>
            <v-row justify="center">
              <v-radio-group v-model="radio_vaccination" row>
                <v-radio label="12歳以上 2回" value="1"></v-radio>
                <v-radio label="全年代 2回" value="2"></v-radio>
              </v-radio-group>
            </v-row>
            <MapAll
              v-if="radio_vaccination == 1"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_Okinawa_Islands"
              :patients="vrsAreaOver12SecondRatio"
              :maxWidth="440"
            >
            </MapAll>
            <MapAll
              v-else-if="radio_vaccination == 2"
              :backgroundColor="backgroundColor"
              :infectionMap="infectionMap.infectionMap_Okinawa_Islands"
              :patients="vrsAreaAllSecondRatio"
              :maxWidth="440"
            >
            </MapAll>
            <VaccinBar></VaccinBar>
            <VaccinCounter
              v-if="radio_vaccination == 1"
              :cases="vrsOver12SecondCounts"
              :ratio="vrsOver12SecondRatio"
            ></VaccinCounter>
            <VaccinCounter
              v-else-if="radio_vaccination == 2"
              :cases="vrsAllSecondCounts"
              :ratio="vrsAllSecondRatio"
            ></VaccinCounter>
            <v-col cols="12" class="caption text-right pb-0 pt-0 pr-6">
              <p class="updatetime">{{ vrsUpdatedate }} 時点</p>
            </v-col>
          </v-card>
        </v-col>

        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card
            class="mx-auto mb-6 pb-6 pl-5 pr-5"
            :color="backgroundColor"
            dark
          >
            <div class="text-h5 text-center font-weight-bold pt-6">
              <p>ワクチン副反応疑い報告</p>
            </div>
            <VaccinSideEffect></VaccinSideEffect>
          </v-card>
        </v-col>

        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card
            class="mx-auto mb-6 pb-6 pl-5 pr-5"
            :color="backgroundColor"
            dark
          >
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>死亡退院</p>
            </div>
            <AgeDeadChart
              :deads="groupDeadAgesTotal"
              title="県内の年齢別死亡退院者数※"
              :subtitle="groupDeadAgesTotalSubTitle"
            >
            </AgeDeadChart>
          </v-card>
        </v-col>

        <v-col lg="4" md="6" sm="8" cols="12">
          <v-card class="mx-auto mb-6 pb-6" :color="backgroundColor" dark>
            <div class="text-h4 text-center font-weight-bold pt-6">
              <p>県・政府の動き</p>
            </div>
            <ArticleTimeLine
              :backgroundColor="backgroundColor"
              :articles="timeLine.items"
            ></ArticleTimeLine>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <div>
          <v-col class="text-left source pl-10 pr-10" cols="12">
            <p>
              データ参照元:
            </p>
            <SourceLinkList
              link="https://www.pref.okinawa.lg.jp/site/hoken/kansen/soumu/press/20200214_covid19_pr1.html"
              name="新型コロナウイルス感染症患者・無症状病原体保有者の発生について"
            />
            <SourceLinkList
              link="https://www.pref.okinawa.lg.jp/site/hoken/kansen/soumu/covid19_hasseijoukyou.html"
              name="沖縄県における新型コロナウイルス感染症発生状況"
            />
            <SourceLinkList
              link="https://www.pref.okinawa.lg.jp/site/hoken/kansen/soumu/press/20200416_covid19_pr.html"
              name="新型コロナウイルスに関連した患者の死亡について"
            />
            <SourceLinkList
              link="https://www.pref.okinawa.lg.jp/site/chijiko/koho/corona/20200702.html"
              name="警戒レベル指標の策定について"
            />
            <SourceLinkList
              link="https://www.pref.okinawa.jp/site/somu/yaeyama/shinko/020429_jyoukyou.html"
              name="八重山地域における新型コロナウイルス感染症状況について"
            />
            <SourceLinkList
              link="https://www.city.miyakojima.lg.jp/kurashi/kenkou/2020-0306-1115-78.html"
              name="宮古島市 新型コロナウイルス感染症患者の発生状況・検査状況について"
            />
            <SourceLinkList
              link="https://www.pref.okinawa.jp/site/chijiko/kohokoryu/covid-19vaccine/sessyujokyo.html"
              name="沖縄県の新型コロナワクチン接種状況"
            />
          </v-col>
        </div>
      </v-row>
    </v-main>
    <v-footer padless color="#242739">
      <v-col class="text-right black--text p-0" cols="12">
        <p class="p-0" style="color:#242739">
          build no. {{ summaryAll.summary_All.UpdateNumber }}
        </p>
      </v-col>
      <v-col class="text-center" cols="12">
        <a href="https://twitter.com/viper_v9v" class="caption"
          >Copyright © {{ new Date().getFullYear() }} @viper_v9v All Rights
          Reserved.</a
        >
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import Title from "./Title";
//import Map from "./Map.vue";
const Map = () => import('./Map.vue');
//import MapAll from "./MapAll.vue";
const MapAll = () => import('./MapAll.vue');
//import MapLegacy from "./MapLegacy.vue";
const MapLegacy = () => import('./MapLegacy.vue');
//import InfectionGraphic from "./InfectionGraphic.vue";
const  InfectionGraphic = () => import('./InfectionGraphic.vue');
//import InfectionGraphicBed from "./InfectionGrphicBed.vue";
const  InfectionGraphicBed = () => import('./InfectionGrphicBed.vue');
//import InfectionGraphicSimple from "./InfectionGraphicSimple.vue";
const  InfectionGraphicSimple = () => import('./InfectionGraphicSimple.vue');
//import VaccinBar from "./VaccinBar.vue";
const  VaccinBar = () => import('./VaccinBar.vue');
//import VaccinCounter from "./VaccinCounter.vue";
const  VaccinCounter = () => import('./VaccinCounter.vue');
//import VaccinSideEffect from "./VaccinSideEffect.vue";
const  VaccinSideEffect = () => import('./VaccinSideEffect.vue');
//import InfectionProgressBar from './InfectionProgressBar.vue'
//import Dashboard from "./Dashboard.vue";
const  Dashboard = () => import('./Dashboard.vue');
//import AlertIndicators from "./AlertIndicators.vue";
const  AlertIndicatorsV2 = () => import('./AlertIndicatorsV2.vue');
//import AlertList from "./AlertList.vue";
const  AlertList = () => import('./AlertList.vue');
//import ArticleTimeLine from "./ArticleTimeLine.vue";
const  ArticleTimeLine = () => import('./ArticleTimeLine.vue');
//import AgePatientsChart from "./AgePatientsChart.vue";
const  AgePatientsChart = () => import('./AgePatientsChart.vue');
//import AgeDeadChart from "./AgeDeadChart.vue";
const  AgeDeadChart = () => import('./AgeDeadChart.vue');
//import SourceLinkList from "./SourceLinkList.vue";
const  SourceLinkList = () => import('./SourceLinkList.vue');
import InfectionMap from "../statics/data/okinawa-infection-map.json";
import SummaryUS from "../statics/data/summary-military-us.json";
import AlertInfo from "../statics/data/alert-info.json";
import SummaryAll from "../statics/data/summary-all.json";
import SummaryOKA from "../statics/data/summary-oka.json";
import SummaryISG from "../statics/data/summary-isg.json";
import SummaryMMY from "../statics/data/summary-mmy.json";
import TimeLineData from "../statics/data/timeline-articles.json";
import DataIndicators from "../statics/data/alert-indicators-2.json";
import PatientTime from "../statics/data/patient-time.json";
import VrsOkinawaCSV from "../statics/data/area-vrs-okinawa-v2.csv";
import PatientDailyCSV from "../statics/data/area-patient-daily.csv";
import Patient7DaysCSV from "../statics/data/area-patient-7days.csv";
import PatientTotalCSV from "../statics/data/area-patient-total.csv";
import AgePatientDailyOKACSV from "../statics/data/oka-patient-age-daily.csv";
import AgePatient7DaysOKACSV from "../statics/data/oka-patient-age-7days.csv";
import AgePatientTotalOKACSV from "../statics/data/oka-patient-age-total.csv";
import AgePatientDailyMMYCSV from "../statics/data/mmy-patient-age-daily.csv";
import AgePatient7DaysMMYCSV from "../statics/data/mmy-patient-age-7days.csv";
import AgePatientTotalMMYCSV from "../statics/data/mmy-patient-age-total.csv";
import AgePatientDailyISGCSV from "../statics/data/isg-patient-age-daily.csv";
import AgePatient7DaysISGCSV from "../statics/data/isg-patient-age-7days.csv";
import AgePatientTotalISGCSV from "../statics/data/isg-patient-age-total.csv";
import DeadAgeTotalCSV from "../statics/data/dead-age-total.csv";
import Moment from "moment";
import {mdiPlus, mdiMinus} from '@mdi/js'

export default {
  name: "Top",
  filters: {
    momentLastUpdate(date) {
      return Moment(date).format("YYYY/MM/DD HH時時点");
    },
  },
  metaInfo: {
    title: "沖縄県 COVID-19 概況",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        hid: "description",
        name: "description",
        content:
          "沖縄県のCOVID-19感染状況を地域別にご覧いただけます。データは毎日更新されます。",
      },
    ],
  },
  components: {
    Title,
    Map,
    MapAll,
    MapLegacy,
    InfectionGraphic,
    InfectionGraphicBed,
    InfectionGraphicSimple,
    VaccinBar,
    VaccinCounter,
    VaccinSideEffect,
    //InfectionProgressBar,
    AlertList,
    ArticleTimeLine,
    AgePatientsChart,
    AgeDeadChart,
    SourceLinkList,
    Dashboard,
    AlertIndicatorsV2,
  },
  computed: {
    hospitalizeOKA: function() {
      return (
        this.summaryOKA.hospitalize +
        this.summaryOKA.hotel +
        this.summaryOKA.home +
        this.summaryOKA.wait -
        this.summaryMMY.hospitalize -
        this.summaryISG.hospitalize
      );
    },
    alertDateRange: function() {
      return this.dataAlertIndicators.alertIndicators.date;
    },
    alertPatients: function() {
      return this.dataAlertIndicators.alertIndicators.patients;
    },
    alertBedRate: function() {
      return this.dataAlertIndicators.alertIndicators.bed_rate;
    },
    alertSevereBedRate: function() {
      return this.dataAlertIndicators.alertIndicators.severe_bed_rate;
    },
    alertLastUpdateTime: function() {
      return this.dataAlertIndicators.lastupdate;
    },
    recuperatorAll: function() {
      return (
        this.summaryOKA.hospitalize +
        this.summaryOKA.hotel +
        this.summaryOKA.home +
        this.summaryOKA.wait
      );
    },
    groupAges1DayOKA: function() {
      let baseDay = this.baseDateOfOKA;
      let records = this.oka_age_patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 1; i < this.oka_age_patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.oka_age_patient1day[0][i]] = {
            name: this.oka_age_patient1day[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.oka_age_patient1day[0][i]] = {
            name: this.oka_age_patient1day[0][i],
            cases: 0,
          };
        }
      }
      //console.log(data);
      return data;
    },
    groupAges1DayOKASubTitle: function() {
      let Title = Moment(this.baseDateOfOKA).format("YYYY/MM/DD");
      return Title;
    },
    groupAges7DaysOKA: function() {
      let baseDay = this.baseDateOfOKA;
      let records = this.oka_age_patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      //console.log(baseDay);
      //console.log(this.oka_age_patient7days);
      //console.log(records);
      for (var i = 1; i < this.oka_age_patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.oka_age_patient7days[0][i]] = {
            name: this.oka_age_patient7days[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.oka_age_patient7days[0][i]] = {
            name: this.oka_age_patient7days[0][i],
            cases: 0,
          };
        }
      }
      return data;
    },
    groupAges7DaysOKASubTitle: function() {
      let baseDay = Moment(this.baseDateOfOKA);
      let Title = Moment(this.baseDateOfOKA)
        .subtract(7, "d")
        .format("YYYY/MM/DD");
      Title += baseDay.format(" ~ YYYY/MM/DD");
      return Title;
    },
    groupAgesTotalOKA: function() {
      let baseDay = this.baseDateOfOKA;
      let records = this.oka_age_patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 1; i < this.oka_age_patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.oka_age_patientTotal[0][i]] = {
            name: this.oka_age_patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.oka_age_patientTotal[0][i]] = {
            name: this.oka_age_patientTotal[0][i],
            cases: 0,
          };
        }
      }
      //console.log(data);
      return data;
    },
    groupAgesTotalOKASubTitle: function() {
      let Title = Moment(this.baseDateOfOKA).format("YYYY/MM/DD までの累計");
      return Title;
    },
    //
    groupAges1DayMMY: function() {
      let baseDay = this.baseDateOfMMY;
      let records = this.mmy_age_patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 1; i < this.mmy_age_patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.mmy_age_patient1day[0][i]] = {
            name: this.mmy_age_patient1day[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.mmy_age_patient1day[0][i]] = {
            name: this.mmy_age_patient1day[0][i],
            cases: 0,
          };
        }
      }
      //console.log(data);
      return data;
    },
    groupAges1DayMMYSubTitle: function() {
      let Title = Moment(this.baseDateOfMMY).format("YYYY/MM/DD");
      return Title;
    },
    groupAges7DaysMMY: function() {
      let baseDay = this.baseDateOfMMY;
      let records = this.mmy_age_patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      //console.log(baseDay);
      //console.log(this.mmy_age_patient7days);
      //console.log(records);
      for (var i = 1; i < this.mmy_age_patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.mmy_age_patient7days[0][i]] = {
            name: this.mmy_age_patient7days[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.mmy_age_patient7days[0][i]] = {
            name: this.mmy_age_patient7days[0][i],
            cases: 0,
          };
        }
      }
      return data;
    },
    groupAges7DaysMMYSubTitle: function() {
      let baseDay = Moment(this.baseDateOfMMY);
      let Title = Moment(this.baseDateOfMMY)
        .subtract(7, "d")
        .format("YYYY/MM/DD");
      Title += baseDay.format(" ~ YYYY/MM/DD");
      return Title;
    },
    groupAgesTotalMMY: function() {
      let baseDay = this.baseDateOfMMY;
      let records = this.mmy_age_patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      //console.log(baseDay);
      //console.log(this.mmy_age_patientTotal);
      //console.log(records);
      for (var i = 1; i < this.mmy_age_patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.mmy_age_patientTotal[0][i]] = {
            name: this.mmy_age_patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.mmy_age_patientTotal[0][i]] = {
            name: this.mmy_age_patientTotal[0][i],
            cases: 0,
          };
        }
      }
      return data;
    },
    groupAgesTotalMMYSubTitle: function() {
      let Title = Moment(this.baseDateOfMMY).format("YYYY/MM/DD までの累計");
      return Title;
    },
    //
    groupAges1DayISG: function() {
      let baseDay = this.baseDateOfISG;
      let records = this.isg_age_patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 1; i < this.isg_age_patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.isg_age_patient1day[0][i]] = {
            name: this.isg_age_patient1day[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.isg_age_patient1day[0][i]] = {
            name: this.isg_age_patient1day[0][i],
            cases: 0,
          };
        }
      }
      //console.log(data);
      return data;
    },
    groupAges1DayISGSubTitle: function() {
      let Title = Moment(this.baseDateOfISG).format("YYYY/MM/DD");
      return Title;
    },
    groupAges7DaysISG: function() {
      let baseDay = this.baseDateOfISG;
      let records = this.isg_age_patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      //console.log(baseDay);
      //console.log(this.isg_age_patient7days);
      //console.log(records);
      for (var i = 1; i < this.isg_age_patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.isg_age_patient7days[0][i]] = {
            name: this.isg_age_patient7days[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.isg_age_patient7days[0][i]] = {
            name: this.isg_age_patient7days[0][i],
            cases: 0,
          };
        }
      }
      return data;
    },
    groupAges7DaysISGSubTitle: function() {
      let baseDay = Moment(this.baseDateOfISG);
      let Title = Moment(this.baseDateOfISG)
        .subtract(7, "d")
        .format("YYYY/MM/DD");
      Title += baseDay.format(" ~ YYYY/MM/DD");
      return Title;
    },
    groupAgesTotalISG: function() {
      let baseDay = this.baseDateOfISG;
      let records = this.isg_age_patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 1; i < this.isg_age_patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.isg_age_patientTotal[0][i]] = {
            name: this.isg_age_patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        } else {
          data[this.isg_age_patientTotal[0][i]] = {
            name: this.isg_age_patientTotal[0][i],
            cases: 0,
          };
        }
      }
      //console.log(data);
      return data;
    },
    groupAgesTotalISGSubTitle: function() {
      let Title = Moment(this.baseDateOfISG).format("YYYY/MM/DD までの累計");
      return Title;
    },
    //
    groupDeadAgesTotal: function() {
      let data = {};
      for (var i = 1; i < this.dead_age_total[0].length; i++) {
        if (Number(this.dead_age_total[1][i]) > 0) {
          data[this.dead_age_total[0][i]] = {
            name: this.dead_age_total[0][i],
            cases: Number(this.dead_age_total[1][i]),
          };
        } else {
          data[this.dead_age_total[0][i]] = {
            name: this.dead_age_total[0][i],
            cases: 0,
          };
        }
      }
      return data;
    },
    groupDeadAgesTotalSubTitle: function() {
      let baseDay = Moment(this.dead_age_total[1][0]);
      let Title = baseDay.format("YYYY/MM/DD 時点");
      return Title;
    },
    //
    patient1DayLatest: function() {
      let baseDay = Moment(this.patientTime.fixdate).format("YYYY-MM-DD");
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let sum = 0;
      for (var i = 1; i < this.patient1day[0].length; i++) {
        if (this.patient1day[0][i] == "全体") sum = Number(records[0][i]);
      }
      return sum;
    },
    patientList7DaysLatest: function() {
      let patients = [];
      let latestDay = this.patientTime.fixdate;
      if (
        Moment(this.patientTime.fixdate) < Moment(this.summaryOKA.lastupdate)
      ) {
        console.log("Time Error: fixdate < lastupdate");
      }
      let records = this.patient1day.filter(function(item) {
        let baseDt = Moment(latestDay).subtract(7, "days");
        let latestDt = Moment(latestDay);
        return (Moment(item[0]) > baseDt) & (Moment(item[0]) <= latestDt);
      }, latestDay);

      for (var i = 1; i < this.patient1day[0].length; i++) {
        if (this.patient1day[0][i] == "全体") {
          for (var j = 0; j < records.length; j++) {
            patients.push(Number(records[j][i]));
          }
        }
      }
      //console.log(patients);
      return patients;
    },
    patient7DaysLatest: function() {
      let baseDay = Moment(this.patientTime.fixdate).format("YYYY-MM-DD");
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let sum = 0;
      for (var i = 1; i < this.patient7days[0].length; i++) {
        if (this.patient1day[0][i] == "全体") sum = Number(records[0][i]);
      }
      return sum;
    },
    patientTotalLatest: function() {
      let baseDay = Moment(this.patientTime.fixdate).format("YYYY-MM-DD");
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let sum = 0;
      for (var i = 1; i < this.patientTotal[0].length; i++) {
        if (this.patient1day[0][i] == "全体") sum = Number(records[0][i]);
      }
      return sum;
    },
    dateCountOfData: function() {
      //console.log(this.patientTime.firstdate);
      let enddate = Moment(this.patientTime.fixdate);
      let begindate = Moment(this.patientTime.firstdate);
      return enddate.diff(begindate, "days");
    },
    baseDateOfOKA: function() {
      let date = Moment(this.patientTime.firstdate);
      return date.add(this.oka_slider, "d").format("YYYY-MM-DD");
    },
    group1DayOKA: function() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient1day[0][i]] = {
            name: this.patient1day[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    group7DaysOKA() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient7days[0][i]] = {
            name: this.patient7days[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    groupTotalOKA() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patientTotal[0][i]] = {
            name: this.patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    sum1dayOKA() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0 && this.patient1day[0][i] == "沖縄本島") {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sum7daysOKA() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patient7days[0][i] == "沖縄本島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sumTotalOKA() {
      let baseDay = this.baseDateOfOKA;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patientTotal[0][i] == "沖縄本島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sum1dayMMY() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0 && this.patient1day[0][i] == "宮古諸島") {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sum7daysMMY() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patient7days[0][i] == "宮古諸島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sumTotalMMY() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patientTotal[0][i] == "宮古諸島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sum1dayISG() {
      let baseDay = this.baseDateOfISG;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patient1day[0][i] == "八重山諸島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sum7daysISG() {
      let baseDay = this.baseDateOfISG;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patient7days[0][i] == "八重山諸島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    sumTotalISG() {
      let baseDay = this.baseDateOfISG;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      var sum = 0;
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (
          Number(records[0][i]) > 0 &&
          this.patientTotal[0][i] == "八重山諸島"
        ) {
          sum += Number(records[0][i]);
        }
      }
      return sum;
    },
    getUsDataDate: function() {
      return Moment(this.summaryUs.lastupdate).format("MM月DD日");
    },
    baseDateOfMMY: function() {
      let date = Moment(this.patientTime.firstdate);
      return date.add(this.mmy_slider, "d").format("YYYY-MM-DD");
    },
    group1DayMMY: function() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient1day[0][i]] = {
            name: this.patient1day[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    group7DaysMMY() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient7days[0][i]] = {
            name: this.patient7days[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    groupTotalMMY() {
      let baseDay = this.baseDateOfMMY;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patientTotal[0][i]] = {
            name: this.patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    baseDateOfISG: function() {
      let date = Moment(this.patientTime.firstdate);
      return date.add(this.isg_slider, "d").format("YYYY-MM-DD");
    },
    group1DayISG: function() {
      let baseDay = this.baseDateOfISG;
      let records = this.patient1day.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient1day[0][i]] = {
            name: this.patient1day[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    group7DaysISG() {
      let baseDay = this.baseDateOfISG;
      let records = this.patient7days.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patient7days[0][i]] = {
            name: this.patient7days[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    groupTotalISG() {
      let baseDay = this.baseDateOfISG;
      let records = this.patientTotal.filter(function(item) {
        return item[0] == baseDay;
      }, baseDay);
      let data = {};
      for (var i = 0; i < this.patientTotal[0].length; i++) {
        if (Number(records[0][i]) > 0) {
          data[this.patientTotal[0][i]] = {
            name: this.patientTotal[0][i],
            cases: Number(records[0][i]),
          };
        }
      }
      return data;
    },
    vrsAreaOver12SecondRatio() {
      let data = {};
      // i は 2 から 那覇市
      for (var i = 2; i < this.vrsokinawa[0].length; i++) {
        if (Number(this.vrsokinawa[8][i]) > 0) {
          data[this.vrsokinawa[0][i]] = {
            name: this.vrsokinawa[0][i],
            cases: Number(this.vrsokinawa[8][i]),
          };
        }
      }
      return data;
    },
    vrsAreaAllSecondRatio() {
      let data = {};
      // i は 2 から 那覇市
      for (var i = 2; i < this.vrsokinawa[0].length; i++) {
        if (Number(this.vrsokinawa[5][i]) > 0) {
          data[this.vrsokinawa[0][i]] = {
            name: this.vrsokinawa[0][i],
            cases: Number(this.vrsokinawa[5][i]),
          };
        }
      }
      return data;
    },
    vrsOver12SecondRatio() {
      if (this.vrsokinawa[0].length) {
        return parseFloat(this.vrsokinawa[8][1]);
      }
      return 0;
    },
    vrsOver12SecondCounts() {
      if (this.vrsokinawa[0].length) {
        return parseInt(this.vrsokinawa[3][1]);
      }
      return 0;
    },
    vrsAllSecondRatio() {
      if (this.vrsokinawa[0].length) {
        return parseFloat(this.vrsokinawa[5][1]);
      }
      return 0;
    },
    vrsAllSecondCounts() {
      if (this.vrsokinawa[0].length) {
        return parseInt(this.vrsokinawa[3][1]);
      }
      return 0;
    },
    vrsUpdatedate() {
      if (this.vrsokinawa[0].length) {
        let date = Moment(this.vrsokinawa[9][1]);
        return date.format("YYYY/MM/DD");
      }
      return "";
    },
    summryUpdatedate() {
      let date = Moment(this.summaryOKA.lastupdate);
      return date.format("YYYY/MM/DD");
    },
    patientList7DaysUpdatedate() {
      let date = Moment(this.patientTime.fixdate);
      return date.format("YYYY/MM/DD");
    },
  },
  data: () => ({
    iconPlus: mdiPlus,
    iconMinus: mdiMinus,
    colorMode: "darkMode",
    backgroundColor: "#1F1E30",
    infectionMap: InfectionMap,
    alertInfo: AlertInfo,
    summaryAll: SummaryAll,
    patientTime: PatientTime,
    summaryOKA: SummaryOKA,
    summaryISG: SummaryISG,
    summaryMMY: SummaryMMY,
    timeLine: TimeLineData,
    dataAlertIndicators: DataIndicators,
    patientTotal: PatientTotalCSV,
    patient7days: Patient7DaysCSV,
    patient1day: PatientDailyCSV,
    vrsokinawa: VrsOkinawaCSV,
    oka_age_patient1day: AgePatientDailyOKACSV,
    oka_age_patient7days: AgePatient7DaysOKACSV,
    oka_age_patientTotal: AgePatientTotalOKACSV,
    mmy_age_patient1day: AgePatientDailyMMYCSV,
    mmy_age_patient7days: AgePatient7DaysMMYCSV,
    mmy_age_patientTotal: AgePatientTotalMMYCSV,
    isg_age_patient1day: AgePatientDailyISGCSV,
    isg_age_patient7days: AgePatient7DaysISGCSV,
    isg_age_patientTotal: AgePatientTotalISGCSV,
    dead_age_total: DeadAgeTotalCSV,
    summaryUs: SummaryUS,
    patientUSGroup: [
      {
        title: "1日間",
        item: SummaryUS.today,
      },
      {
        title: "累計",
        item: SummaryUS.total,
      },
    ],
    oka_tab: 1,
    isg_tab: 1,
    mmy_tab: 1,
    us_tab: 0,
    oka_slider: 0,
    mmy_slider: 0,
    isg_slider: 0,
    radio_oka: "2",
    radio_mmy: "2",
    radio_isg: "2",
    radio_us: "1",
    radio_vaccination: "1",
    patient_1day_oka: [],
    patient_7days_oka: [],
  }),
  head: {
    meta: [
      {
        name: "google-site-verification",
        content: "sovG78KAcPLvOO2vx2xy_x4Ru0Qvmi8YDci1diy3XlI",
      },
    ],
  },
  created: function() {
    document.documentElement.setAttribute("lang", "ja");

    this.oka_slider = this.dateCountOfData;
    this.mmy_slider = this.dateCountOfData;
    this.isg_slider = this.dateCountOfData;
  },
  mounted: function() {
    if(localStorage.radio_oka != undefined) this.radio_oka = localStorage.radio_oka;
    if(localStorage.radio_mmy != undefined) this.radio_mmy = localStorage.radio_mmy;
    if(localStorage.radio_isg != undefined) this.radio_isg = localStorage.radio_isg;
    if(localStorage.radio_us != undefined) this.radio_us = localStorage.radio_us;
    if(localStorage.radio_vaccination != undefined) this.radio_vaccination = localStorage.radio_vaccination;

    this.getArray1DayOKA();
    this.getArray7DaysOKA();
  },
  watch:{
    radio_oka: function(newValue) {
      localStorage.radio_oka = newValue;
    },
    radio_mmy: function(newValue) {
      localStorage.radio_mmy = newValue;
    },
    radio_isg: function(newValue) {
      localStorage.radio_isg = newValue;
    },
    radio_us: function(newValue) {
      localStorage.radio_us = newValue;
    },
    radio_vaccination: function(newValue) {
      localStorage.radio_vaccination = newValue;
    }
  },
  methods: {
    baseDateSlider(value) {
      let date = Moment(this.patientTime.firstdate);
      return date.add(value, "d").format("MM/DD");
    },
    getClientUpdateTime() {
      let updateTimeCookies = this.$cookies.get(
        "viper_v9v.covid19map.updateTime"
      );
      //console.log(localStorage.updateTime);
      //console.log(updateTimeCookies);
      return updateTimeCookies == undefined
        ? localStorage.updateTime
        : updateTimeCookies;
    },
    setClientUpdateTime(time) {
      this.$cookies.set("viper_v9v.covid19map.updateTime", time, {
        expires: 0.5,
      });
      localStorage.updateTime = time;
    },
    getArray1DayOKA() {
      let firstDay = Moment(this.patientTime.firstdate);
      for (var i = 0; i < this.patient1day[0].length; i++) {
        if (this.patient1day[0][i] == "沖縄本島") {
          for (var j = 1; j < this.patient1day.length; j++) {
            if (firstDay <= Moment(this.patient1day[j][0]))
              this.patient_1day_oka.push(Number(this.patient1day[j][i]));
          }
          break;
        }
      }
      //console.log(this.patient_1day_oka);
    },
    getArray7DaysOKA() {
      let firstDay = Moment(this.patientTime.firstdate);
      for (var i = 0; i < this.patient7days[0].length; i++) {
        if (this.patient7days[0][i] == "沖縄本島") {
          for (var j = 1; j < this.patient7days.length; j++) {
            if (firstDay <= Moment(this.patient7days[j][0]))
              this.patient_7days_oka.push(Number(this.patient7days[j][i]));
          }
          break;
        }
      }
      //console.log(this.patient_7days_oka);
    },
    decrement_oka() {
      if (0 < this.oka_slider) {
        this.oka_slider--;
      }
    },
    increment_oka() {
      if (this.oka_slider < this.dateCountOfData) {
        this.oka_slider++;
      }
    },
    decrement_mmy() {
      if (0 < this.mmy_slider) {
        this.mmy_slider--;
      }
    },
    increment_mmy() {
      if (this.mmy_slider < this.dateCountOfData) {
        this.mmy_slider++;
      }
    },
    decrement_isg() {
      if (0 < this.isg_slider) {
        this.isg_slider--;
      }
    },
    increment_isg() {
      if (this.isg_slider < this.dateCountOfData) {
        this.isg_slider++;
      }
    },
  },
};
</script>

<style lang="sass">
.v-application
  font-family: "Meiryo UI", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Yu Gothic UI", "MS PGothic", sans-serif !important
</style>

<style scoped>
.wrap {
  overflow: hidden;
}

.darkMode {
  background-color: "#1F1E30";
}

.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.charts-slider {
  position: relative;
  width: 88%;
}

.charts-slider-chart {
  width: 100%;
}

.charts-slider-main {
  position: absolute;
  height: auto;
  width: 98%;
  -webkit-transform: translateX(0%) translateY(-51%);
  transform: translateX(0%) translateY(-51%);
}

.source p {
  color: #909090;
}
</style>
